module.exports = __webpack_public_path__ + "static/media/bquizResult.33b73c67.svg";